const CHALLENGES = {
  CoderbyteChallenge: "Coderbyte",
  CodilityChallenge: "Codility",
};

const CHALLENGE_ITEM_TYPES = {
  CODING: "CODING_CHALLENGE",
  MCQ: "MULTIPLE_CHOICE",
  OPEN_ENDED: "OPEN_ENDED",
};

const CHALLENGE_ITEM_ORDER = [CHALLENGE_ITEM_TYPES.CODING, CHALLENGE_ITEM_TYPES.MCQ, CHALLENGE_ITEM_TYPES.OPEN_ENDED];

export { CHALLENGE_ITEM_TYPES, CHALLENGE_ITEM_ORDER };

export default CHALLENGES;
